import { render, staticRenderFns } from "./ReportImageOverview.vue?vue&type=template&id=d4653a82&"
import script from "./ReportImageOverview.vue?vue&type=script&lang=ts&"
export * from "./ReportImageOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports